import {
  Inbox, ClipboardCheck, CalendarClock, TestTubes, Microscope, ClipboardList, BadgeDollarSign,
  Bell, ShieldCheck,
} from "lucide-react";
import LuxSidebar from "./LuxSidebar";
import { useUnread } from "@/lib/useUnread";

const NAV = [
  { section: "Queue",     to: "/laboratory/orders",       label: "Assigned Orders",       icon: Inbox,           tid: "lab-nav-orders" },
  { section: "Queue",     to: "/laboratory/dispense",     label: "Availability & Quote",  icon: ClipboardCheck,  tid: "lab-nav-dispense" },
  { section: "Specimens", to: "/laboratory/collection",   label: "Collection Scheduling", icon: CalendarClock,   tid: "lab-nav-collection" },
  { section: "Specimens", to: "/laboratory/specimens",    label: "Specimen Tracking",     icon: TestTubes,       tid: "lab-nav-specimens" },
  { section: "Specimens", to: "/laboratory/processing",   label: "Processing",            icon: Microscope,      tid: "lab-nav-processing" },
  { section: "Specimens", to: "/laboratory/results",      label: "Results",               icon: ClipboardList,   tid: "lab-nav-results" },
  { section: "Finance",   to: "/laboratory/settlements",  label: "Settlements",           icon: BadgeDollarSign, tid: "lab-nav-settlements" },
  { section: "Console",   to: "/partner/account",         label: "My Business",           icon: ShieldCheck,     tid: "lab-nav-account" },
  { section: "Console",   to: "/partner/notifications",   label: "Alert Preferences",     icon: Bell,            tid: "lab-nav-alerts" },
];

export default function LaboratoryNav() {
  const { partner_total } = useUnread();
  // Badge counts unread GUEST MESSAGES, not orders.
  const items = NAV.map((n) =>
    n.to === "/laboratory/orders"
      ? { ...n, badge: partner_total, badgeTitle: "Unread guest messages" }
      : n);
  return <LuxSidebar items={items} subtitle="Partner Console" footer="Assigned orders only · no clinical edits"
    testidPrefix="lab-nav" homePath="/laboratory/orders" />;
}
